import { ApiResponse } from 'apisauce'

import { all, call, put, takeLatest } from 'redux-saga/effects'

import { loading } from '~/store/modules/global/actions'
import { store } from '~/store'

import { toast } from '@psdhub/common/utils'
import { getInstance, setAuthorization } from '@psdhub/api'

import { ClassesAPI } from './types'
import { Actions, classesFailure, classesSuccess } from './actions'

export function* getClasses(): Generator {
  yield put(loading(true))

  const { info } = store.getState().user

  const { reduced_token } = store.getState().auth

  if (reduced_token) {
    setAuthorization(reduced_token)
  }

  const api = getInstance()

  const response = yield call(() => {
    return api.get('/Escola/Turmas', {
      userGuid: info?.guid
    })
  })

  const { ok, data } = response as ApiResponse<{ conteudo: ClassesAPI[] }>

  const prepareData: ClassesAPI[] | undefined = data?.conteudo
    .map(i => {
      return {
        id: i.id,
        ativo: i.ativo,
        alunos: i.alunos,
        nome: i.nome,
        serie: i.serie
      }
    })
    .filter(i => i.ativo)

  yield put(loading(false))

  if (!ok) {
    toast.error('Erro ao buscar turmas!')
    return yield put(classesFailure())
  }

  return yield put(classesSuccess(prepareData))
}

export default all([takeLatest(Actions.GET_REQUEST, getClasses)])
